import api from "./api";

const idempotencyKey = () =>
  "sales-" + Date.now() + "-" + Math.random().toString(16).slice(2);

const withIdempotency = (headers = {}, operationKey = null) => ({
  headers: {
    ...headers,
    "Idempotency-Key": operationKey || idempotencyKey(),
  },
});

export const salesService = {
  createBudget(payload) {
    return api.post("/sales/create-budget", payload, withIdempotency());
  },

  /**
   * Envía el presupuesto a caja y reserva stock
   */
  sendToCashier(id, actor) {
    return api.post(`/sales/send-to-cashier/${id}`, { actor }, withIdempotency());
  },

  cancelBudget(id, actor) {
    return api.post(`/sales/cancel-budget/${id}`, { actor }, withIdempotency());
  },

  processReturn(payload) {
    return api.post("/sales/process-return", payload, {
      ...withIdempotency(),
      // La conciliación de un CAE previo puede requerir una consulta a WSFE.
      timeout: 180000,
    });
  },

  processDebitNote(invoiceId, payload) {
    return api.post(`/sales/invoices/${invoiceId}/debit-note`, payload, {
      ...withIdempotency(),
      // La autorización y eventual conciliación con WSFE puede demorar.
      timeout: 180000,
    });
  },

  sendInvoiceEmail(id, email) {
    return api.post(`/sales/send-invoice-email/${id}`, { email }, withIdempotency());
  },

  /**
   * Procesa el cobro y la factura (Caja)
   */
  processSale(payload, operationKey = null) {
    return api.post("/sales/process-sale", payload, {
      ...withIdempotency({}, operationKey),
      // WSFE puede demorar; no abortar una emisión fiscal mientras ARCA responde.
      timeout: 180000,
    });
  },

  getAvailableCredit(id) {
    return api.get(`/sales/budgets/${id}/available-credit`);
  },

  previewBudget(id) {
    return api.get(`/sales/budgets/${id}/preview`);
  },

  editFromCashier(id, payload) {
    return api.post(`/sales/budgets/${id}/edit-from-cashier`, payload, withIdempotency());
  },

  downloadInvoicePdf(id) {
    return api.get(`/sales/download-invoice-pdf/${id}`, {
      responseType: "blob",
      // La generación se hace en el servidor y puede requerir más tiempo que
      // las consultas normales de la aplicación.
      timeout: 90000,
    });
  },

  downloadBudgetPdf(id) {
    return api.get(`/sales/download-budget-pdf/${id}`, { responseType: "blob" });
  }
};
